export const getCurrentBaseUrl = () => {
  const protocol = window.location.protocol;
  const host = window.location.host;
  const urlComplete = `${protocol}//${host}`;
  return urlComplete;
};
